import { OrderPayablesGroupByTable } from "../OrderPayablesGroupByTable";
import { OrderPayablesHold } from "../OrderPayablesHold";
import { OrderPayablesPendingReview } from "../OrderPayablesPendingReview";
import { OrderPayablesProcess } from "../OrderPayablesProcess";
import { Button, DataSource, Layout, LayoutHeader, Panel, Splitter, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderPayables extends Layout {
    buttonArchiveVoids: Button;
    layoutGroupBy: OrderPayablesGroupByTable;
    layoutHold: OrderPayablesHold;
    layoutOrderPayablesProcess: OrderPayablesProcess;
    layoutPendingReview: OrderPayablesPendingReview;
    layoutheaderOrderPayables: LayoutHeader;
    panelContent: Panel;
    sourceOrderPayablesCache: DataSource;
    sourceOrderPayablesProfile: DataSource;
    sourceVoidedPayablesOrderPayables: DataSource;
    splitterOrderPayables: Splitter;
    tabHold: Tab;
    tabPendingReview: Tab;
    tabProcess: Tab;
    tabsetOrderPayables: Tabset;
    textboxDateRange: Textbox;
}
